import axios from 'axios';
import { listDocs, getDoc, createDoc, updateDoc, deleteDoc } from './appDataClient';
import { API_URL, pollingSubscription } from './adapters';

// Backup sources and run logs are stored through /api/app-data. Triggering a
// run calls /api/backup, which drives the VPS Google Sheets sync; the old
// implementation posted to a Firebase Function that no longer exists.

const SOURCES = 'backupSources';
const LOGS = 'backupLogs';

// ===== Backup sources =====

export const createBackupSource = async (sourceData) =>
  createDoc(SOURCES, { ...sourceData, isActive: true, lastSyncAt: null });

export const getBackupSource = async (sourceId) => getDoc(SOURCES, sourceId);

export const getAllBackupSources = async () => listDocs(SOURCES);

export const updateBackupSource = async (sourceId, updates) =>
  updateDoc(SOURCES, sourceId, updates);

// Removing a source also removes its run logs, which record it as their parent.
export const deleteBackupSource = async (sourceId) => deleteDoc(SOURCES, sourceId);

// ===== Run logs =====

export const createBackupLog = async (logData) =>
  createDoc(LOGS, { ...logData, parentId: logData.sourceId || null });

export const updateBackupLog = async (logId, updates) => updateDoc(LOGS, logId, updates);

export const getBackupLogs = async (sourceId = null, limit = 50) => {
  const logs = await listDocs(LOGS, sourceId ? { parentId: sourceId } : {});
  return logs.slice(0, limit);
};

// ===== Execution =====

export const triggerBackup = async (sourceId) => {
  try {
    const { data } = await axios.post(`${API_URL}/backup/trigger/${sourceId}`);
    return { success: true, logId: data.logId, result: data.result };
  } catch (error) {
    const message = error.response?.data?.error || error.message;
    console.error('Error triggering backup:', message);
    return { success: false, error: message, logId: error.response?.data?.logId || null };
  }
};

export const subscribeToBackupSources = (callback) =>
  pollingSubscription(getAllBackupSources, callback);

export const subscribeToBackupLogs = (sourceId, callback) =>
  pollingSubscription(() => getBackupLogs(sourceId), callback);

export const validateGoogleSheetsUrl = (url) => {
  const pattern = /https:\/\/docs\.google\.com\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/;
  return pattern.test(url);
};

export const extractSpreadsheetId = (url) => {
  const pattern = /https:\/\/docs\.google\.com\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/;
  const match = url.match(pattern);
  return match ? match[1] : null;
};

export const getBackupStats = async () => {
  const { data } = await axios.get(`${API_URL}/backup/stats`);
  return data;
};
